import { type FilterChoiceType } from '../types'
import { useChangelogParams } from '../changelogRouteUtil'

export default function useFilterType(): FilterChoiceType {
  const { filterType } = useChangelogParams()
  return (filterType?.toUpperCase().replace(/-/g, '_') as FilterChoiceType) ?? 'ALL'
}
